import { createFileRoute } from '@tanstack/react-router';

import { automaticPixListSearch, bankAccountAutomaticPixPaidScreen, loadBankAccountMessages, loadBankAccountScreens } from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

// Pagamentos realizados do Pix Automático (`router.tsx:557-561`), a aba Realizados.
export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados')({
  validateSearch: automaticPixListSearch,
  staticData: { screen: bankAccountAutomaticPixPaidScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountAutomaticPixPaidScreen'),
});
